(function () {
  "use strict";

  var MONEY = function (c) { return "$" + (c / 100).toFixed(2); };

  // Mobile nav
  var mt = document.querySelector(".menu-toggle"), mn = document.querySelector(".mobile-nav");
  if (mt && mn) mt.addEventListener("click", function () { mn.classList.toggle("open"); });

  // Hero slideshow
  document.querySelectorAll(".hero").forEach(function (h) {
    var track = h.querySelector(".hero-slides"), slides = h.querySelectorAll(".hero-slide"),
        dots = h.querySelectorAll(".hero-dots button"), i = 0, t;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = "translateX(-" + i * 100 + "%)";
      dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
    }
    function auto() { t = setInterval(function () { go(i + 1); }, 5000); }
    function stop() { clearInterval(t); }
    var p = h.querySelector(".hero-prev"), nx = h.querySelector(".hero-next");
    p && p.addEventListener("click", function () { stop(); go(i - 1); auto(); });
    nx && nx.addEventListener("click", function () { stop(); go(i + 1); auto(); });
    dots.forEach(function (d, k) { d.addEventListener("click", function () { stop(); go(k); auto(); }); });
    if (slides.length > 1) auto();
  });

  // Cart drawer
  var drawer = document.querySelector(".cart-drawer"), overlay = document.querySelector(".cart-overlay");
  function openCart() { drawer.hidden = false; overlay.hidden = false; document.body.style.overflow = "hidden"; }
  function closeCart() { drawer.hidden = true; overlay.hidden = true; document.body.style.overflow = ""; }
  document.querySelectorAll(".cart-toggle").forEach(function (b) {
    b.addEventListener("click", function () { renderCart(); openCart(); });
  });
  var cc = document.querySelector(".cart-close");
  cc && cc.addEventListener("click", closeCart);
  overlay && overlay.addEventListener("click", closeCart);

  function renderCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var box = document.querySelector(".cart-items");
      document.querySelectorAll(".cart-count").forEach(function (el) { el.textContent = cart.item_count; });
      if (cart.items.length) {
        box.innerHTML = cart.items.map(function (it, ix) {
          var img = it.image ? '<img src="' + it.image + '&width=160" alt="">' : '<img src="" alt="" style="background:#f5f5f4">';
          return '<div class="cart-line">' + img + '<div><div class="cl-title">' + it.product_title + '</div>' +
            '<div class="cl-variant">' + it.variant_title + '</div>' +
            '<div class="qty"><button type="button" data-line="' + (ix + 1) + '" data-q="' + (it.quantity - 1) + '">\u2212</button><span>' + it.quantity + '</span>' +
            '<button type="button" data-line="' + (ix + 1) + '" data-q="' + (it.quantity + 1) + '">+</button></div></div>' +
            '<div class="cl-price">' + MONEY(it.final_line_price) + '</div></div>';
        }).join("");
        box.querySelectorAll(".qty button").forEach(function (b) {
          b.addEventListener("click", function () {
            fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.q }) }).then(renderCart);
          });
        });
      } else {
        box.innerHTML = '<p class="cart-empty">Your bag is empty.</p>';
      }
      document.querySelector(".cart-subtotal-amount").textContent = MONEY(cart.total_price);
    });
  }

  window.B2BD_addToCart = function (variantId) {
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
      .then(function () { renderCart(); openCart(); });
  };

  // Product card swatches: switch the card image + link variant
  document.querySelectorAll(".pcard").forEach(function (card) {
    var img = card.querySelector(".pcard-imgwrap img"), link = card.querySelector("a.pcard-link");
    card.querySelectorAll(".swatch").forEach(function (sw) {
      sw.addEventListener("click", function (e) {
        e.preventDefault();
        card.querySelectorAll(".swatch").forEach(function (s) { s.classList.remove("on"); });
        sw.classList.add("on");
        if (sw.dataset.img) img.src = sw.dataset.img;
        if (link && sw.dataset.variant) link.href = sw.dataset.url + "?variant=" + sw.dataset.variant;
      });
    });
  });

  // Product page
  var pd = document.querySelector(".pd");
  if (pd) {
    var data = JSON.parse(document.getElementById("pd-json").textContent);
    var colorBtns = pd.querySelectorAll(".pd-colors .swatch"),
        sizeBtns = pd.querySelectorAll(".size-btn"),
        atc = document.getElementById("pd-atc"),
        priceEl = document.getElementById("pd-price"),
        mainImg = document.getElementById("pd-main-img"),
        thumbs = document.getElementById("pd-thumbs"),
        colorName = document.getElementById("pd-color-name"),
        colorDesc = document.getElementById("pd-color-desc");
    var state = { color: data.initialColor, size: null, view: "Back" };

    function variantsFor(color) { return data.variants.filter(function (v) { return v.option1 === color; }); }
    function current() {
      return variantsFor(state.color).find(function (v) { return v.option2 === state.size; }) || null;
    }
    function views() { return Object.keys(data.images[state.color] || {}); }

    function renderThumbs() {
      var vs = views();
      if (!vs.length) { thumbs.innerHTML = ""; return; }
      if (vs.indexOf(state.view) < 0) state.view = vs[0];
      thumbs.innerHTML = vs.map(function (v) {
        return '<button type="button" class="' + (v === state.view ? "on" : "") + '" data-view="' + v + '">' +
          '<img src="' + data.images[state.color][v] + '" alt="' + v + ' view" loading="lazy"><span>' + v + '</span></button>';
      }).join("");
      thumbs.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () { state.view = b.dataset.view; render(); });
      });
    }

    function renderSizes() {
      var vs = variantsFor(state.color);
      sizeBtns.forEach(function (b) {
        var v = vs.find(function (x) { return x.option2 === b.dataset.size; });
        b.classList.toggle("off", !v || !v.available);
        b.classList.toggle("on", state.size === b.dataset.size);
      });
    }

    function render() {
      renderThumbs();
      renderSizes();
      if (colorName) colorName.textContent = state.color;
      if (colorDesc) colorDesc.textContent = (data.colorDesc && data.colorDesc[state.color]) || "";
      if (mainImg && data.images[state.color]) mainImg.src = data.images[state.color][state.view];
      var v = current();
      if (v) {
        priceEl.innerHTML = MONEY(v.price) + (v.compare_at_price && v.compare_at_price > v.price
          ? "<s>" + MONEY(v.compare_at_price) + '</s><span class="comp">Comp. Value</span>' : "");
        atc.disabled = !v.available;
        atc.innerHTML = (v.available ? "ADD TO CART \u2014 " + MONEY(v.price) : "SOLD OUT") + "<small>In-Stock: Ready to Ship</small>";
      } else {
        priceEl.innerHTML = "";
        atc.disabled = true;
        atc.innerHTML = "SELECT A SIZE<small>&nbsp;</small>";
      }
      colorBtns.forEach(function (b) { b.classList.toggle("on", b.dataset.color === state.color); });
    }

    colorBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        state.color = b.dataset.color;
        var vs = variantsFor(state.color);
        if (!vs.some(function (v) { return v.option2 === state.size && v.available; })) {
          var f = vs.find(function (v) { return v.available; });
          state.size = f ? f.option2 : null;
        }
        render();
      });
    });
    sizeBtns.forEach(function (b) {
      b.addEventListener("click", function () { state.size = b.dataset.size; render(); });
    });
    atc.addEventListener("click", function () {
      var v = current();
      if (v && v.available) {
        atc.disabled = true;
        window.B2BD_addToCart(v.id).finally(function () { atc.disabled = false; });
      }
    });
    render();
  }
})();
